export default __webpack_public_path__ + "static/media/fuelEnDetailTruckMobile.252a4c19.jpg";